/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelLoadBoardService.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/load-board-service";

export class AutogenModelLoadBoardService<RowType extends ModelRow> extends Endpoint<RowType, RowLoadBoardServiceFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowLoadBoardService extends ModelRow<RowLoadBoardServiceFields> {
	constructor(values?: Partial<RowLoadBoardServiceFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowLoadBoardServiceFields {
	access_token: string;
	account_id: string;
	address: string;
	available_tractors: string;
	carrier_lane_updates: string;
	carrier_updates: string;
	client_id: string;
	client_secret: string;
	company_id: string;
	email_post_failure: string;
	extract_capacity: string;
	ftp_connect_mode: string;
	header_data: string;
	id: string;
	is_active: string;
	last_posting_date: Date;
	last_refresh_date: Date;
	local_file: string;
	main_account_user_id: string;
	method: string;
	passwd: string;
	pnn_post_role: string;
	pnn_schedule_id: string;
	port: number;
	posting_format: string;
	posting_frequency: number;
	proxy: string;
	refresh_daily: string;
	refresh_schedule_code: string;
	refresh_token: string;
	remote_dir: string;
	remote_file: string;
	report_carrier: string;
	send_auto_update: string;
	service_name: string;
	service_type: string;
	ssh_key_file: string;
	ssh_key_pwd: string;
	token_expires: Date;
	truckstop_user_email: string;
	userid: string;
}

